<template>
  <div class="performers">
    <div class="ExpertsHub">
      <div class="card-container">
        <div class="expert-cards">
          <!-- <div class="top-margin-10">
            <div class="flex">
              <el-select
                v-model="search_expert"
                filterable
                remote
                reserve-keyword
                placeholder="Search Expert E.g. Motilal Os"
                class="search-input"
                size="small"
                clearable
                :loading="is_search_expert_loading"
                :remote-method="searchExpertList"
                @change="handleExpert(search_expert)"
              >
                <el-option
                  v-for="expert in searched_expert_list"
                  :key="expert.id"
                  :label="expert.full_name"
                  :value="expert.id"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
          <el-row>
            <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
            <el-col :xs="22" :sm="22" :md="20" :lg="20" :xl="20">
              <div class="font-weight-600 top-margin-25 expert-head">
                TOP EXPERTS
              </div>
              <el-row :gutter="10" style="margin-top: 30px">
                <el-col
                  :xs="24"
                  :sm="12"
                  :md="8"
                  :lg="6"
                  :xl="6"
                  v-for="(expert, expert_index) in recommended_experts_list"
                  :key="expert_index"
                >
                  <!-- :style="[
                    userProfile.id == expert.id
                      ? { pointerEvents: 'none' }
                      : '',
                  ]" -->
                  <div v-loading="expert.is_loading">
                    <ExpertHubProfileCard
                      class="cursor-pointer"
                      :user_details="expert"
                      :display_profile_verified_icons="true"
                      @goToExpertStore="goToExpertStore(expert)"
                      @followExpert="followExpert(expert_index, expert)"
                    ></ExpertHubProfileCard>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <NoDataFound
            style="padding: 0"
            v-if="!is_expert_list_loading && !recommended_experts_list.length"
          ></NoDataFound>

          <!-- btn to load more recos -->
          <div
            class="show-more-tab"
            v-if="
              this.number_of_pages > this.page_no && !is_expert_list_loading
            "
            @click="loadMoreExperts()"
          >
            Load more
          </div>

          <div class="text-center" v-if="is_expert_list_loading">
            <img
              src="../assets/images/company/loader.svg"
              style="height: 80px; width: 80px"
            />
          </div>
        </div>
      </div>
    </div>
    <Retailnavbar
      style="position: fixed;
    top: 0;
    width: 100%;"
    ></Retailnavbar>
    <RetailFooter></RetailFooter>
  </div>
</template>

<script>
// import { screenSize } from "../../mixins/ScreenSize.js";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";
import { serverAddr } from "../networkConfig";
// import { EventBus } from "../../eventBus";
// import { loginNetworkCallBack } from "../../mixins/login.NetworkCallback";
import NoDataFound from "@/components/NoDataFound.vue";
import ExpertHubProfileCard from "@/components/ExpertHubProfileCard.vue";

export default {
  name: "Performers",

  components: { RetailFooter, Retailnavbar, NoDataFound, ExpertHubProfileCard },

  mixins: [],

  data() {
    return {
      recommended_experts_list: [],
      is_expert_list_loading: false,
      number_of_pages: null,
      page_per_entries: 8,
      is_scroll_enabled: false,
      page_no: 1,
    };
  },

  mounted() {
    this.getAllExpertList();
  },

  methods: {
    loadMoreExperts() {
      if (this.userProfile) {
        this.page_no = this.page_no + 1;
        // this.number_of_pages = null;     //to disable load more tab
        this.getAllExpertList();
      } else {
        this.$router.push({
          name: "login",
        });
      }
    },
    // api to getAllExpertList
    getAllExpertList() {
      this.is_expert_list_loading = true;
      serverAddr
        .post("/performers/v1/open_api/expert_hub", {
          page_number: this.page_no,
          page_per_entries: 8,
          period: "MAX",
        })
        .then((response) => {
          if (response.data.status) {
            this.number_of_pages = response.data.pagination.total_pages;
            this.page_no = response.data.pagination.current_page;

            response.data.data.forEach((e) => {
              let obj = {
                profile_pic: e.pic ? "/Media/" + e.pic : "",
                name: e.full_name,
                rank: e.rank,
                profession: e.profession,
                company: e.user_company_name,
                performer_rating: e.overall_rating,
                portfolio_rating: e.user_rating,
                accuracy: e.accuracy,
                success_rate: e.success_rate,
                live_reco: e.live_reco,
                total_reco: e.total_reco,
                following: e.following,
                follower: e.follower,
                emp_type: e.response_type,
                id: e.id,
                is_followed: e.follow_option_enable,
                is_loading: false,
                is_public: e.is_public,
                annualised_roi: e.annual_roi,
                mark_as_verified: e.mark_as_verified,
              };

              this.recommended_experts_list.push(obj);
            });

            // this.is_scroll_enabled = true;         //enable scroll for more stocks
            this.is_expert_list_loading = false;
          } else {
            this.is_expert_list_loading = false;
            this.page_no = 0; //if api fails then reset to page 0
            this.number_of_pages = 0; //if api fails then reset to page 0
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_expert_list_loading = false;
          this.page_no = 0; //if api fails then reset to page 0
          this.number_of_pages = 0; //if api fails then reset to page 0
        });
    },

    goToExpertStore(expert) {
      var expertStorePath;
      // expertStorePath = "/expert-store";
      if (this.userProfile) {
        expertStorePath = "/expert-store";
      } else {
        expertStorePath = "/expert-cover";
      }
      // on selecting expert commited blank obj in store to cleare existing expert details
      this.$store.commit("commitExpertDetails", {});
      this.$router.push({
        path: expertStorePath,
        query: {
          user_id: expert.id,
          user: expert.emp_type,
          name: expert.name,
        },
      });
    },
  },
  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "../../css/variable.scss";
// @import "../../css/common.scss";
.performers{
  margin-top: 60px;
}
.expert-head {
  font-size: 1.2rem;
  margin: 55px 0 0px;
  font-weight: 600;
}
</style>
